
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Button, Container, Row, Col, Card, Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { baseUrl } from "../../ApiCheck/Constant";
import Context from '../../Context/Context';
import { useNavigate } from 'react-router-dom';
import Loader from '../../ApiCheck/Loader';
import moment from "moment"
const Orders = () => {
  const [orders, setOrders] = useState([]);
const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  console.log("user", user)
  const [loading, setLoading] = useState(false);
    const fetchOrder = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/api/getorder`);
        const data = response.data.data;
        setOrders(data);
      } catch (error) {
        toast.error('Failed to fetch order. Please try again.');
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (!user.isAuth) {
        navigate('/');
      } else {
        fetchOrder();
      }
    }, [user]);
  
    const handleUpdateStatus = async (orderId, newStatus) => {
      try {
        await axios.put(`${baseUrl}/api/updateorder/${orderId}`, {
          orderStatus: newStatus,
        });
        toast.success("Order status updated");
        fetchOrder();
      } catch (error) {
        toast.error("Failed to update status");
      }
    };

    const handleDelete = async (id) => {
      if (window.confirm('Are you sure you want to delete this order?')) {
        try {
          await axios.delete(`${baseUrl}/api/deleteorder/${id}`);
          toast.success('Order deleted');
          fetchOrder(); // refresh list
        } catch (error) {
          toast.error('Failed to delete order');
        }
      }
    };
    const orderStatusOptions = ["pending", "processing", "shipped", "delivered", "cancelled"];
  return (
    loading ? (
            <Loader />
          ): (

      
    <div className="container mt-4">
      <h2 className="mb-4">Your Orders</h2>
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Id</th>
              <th>Item</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Order Id</th>
              <th>Order Status</th>
              <th>Address</th>
              <th>created At</th>
              {user && user?.user?.role === 'ADMIN' && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((order, index) => (
                <tr key={order.id}>
                  <td>{index + 1}</td>
                  <td>{order?.productID.map((product) => product?.name).join(', ')}</td>
                  <td>{order.productID?.length}</td>
                  <td>{order?.productID.reduce((total,product) => total + Number(product?.price || 0), 0 )}</td>
                  <td>{order?.razorpay_order_id}</td>
                  <td>{order?.orderStatus || "Pending"}</td>

                  <td>{
                    `${order?.addresseID?.addressLine1},${order?.addresseID?.addressLine2},
                    ${order?.addresseID?.city}, ${order?.addresseID?.state} - ${order?.addresseID?.pinCode}, ${order?.addresseID?.country}
                     `
                  }</td>
                  <td>{moment(order.createdAt).format("DD-MM-YYYY hh:mm:ss A")}</td>

                     {user && user.user.role === 'ADMIN' && (
            
                           <td>
                                            <Dropdown>
                                              <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                ⋮
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu>
                                              {orderStatusOptions.map((status) => (
        <Dropdown.Item
          key={status}
          className='bg-dark'

          onClick={() => handleUpdateStatus(order._id, status)}
          active={order.orderStatus}
        >
          {order.orderStatus?.toLowerCase() === status.toLowerCase() ? (
            <strong>{status.charAt(0).toUpperCase() + status.slice(1)} ✅</strong>
          ) : (
            status.charAt(0).toUpperCase() + status.slice(1)
          )}
        </Dropdown.Item>
      ))}
      <Dropdown.Divider />
        <Dropdown.Item  onClick={() => handleDelete(order._id)}>
                                                  Delete
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </td>
)}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
          )
  );
};

export default Orders;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { baseUrl } from "../../ApiCheck/Constant";
// import { useNavigate } from 'react-router-dom';
// import Loader from '../../ApiCheck/Loader';
// import moment from "moment";

// const Orders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.user);

//   const fetchOrder = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${baseUrl}/api/getorder`);
//       setOrders(response.data.data);
//     } catch (error) {
//       toast.error('Failed to fetch orders.');
//     } finally {
//       setLoading(false);
//     }
//   };

  // const handleDelete = async (id) => {
  //   if (window.confirm('Are you sure you want to delete this order?')) {
  //     try {
  //       await axios.delete(`${baseUrl}/api/deleteorder/${id}`);
  //       toast.success('Order deleted');
  //       fetchOrder(); // refresh list
  //     } catch (error) {
  //       toast.error('Failed to delete order');
  //     }
  //   }
  // };

  // const handleUpdateStatus = async (orderId, newStatus) => {
  //   try {
  //     await axios.put(`${baseUrl}/api/updateorder/${orderId}`, {
  //       orderStatus: newStatus,
  //     });
  //     toast.success("Order status updated");
  //     fetchOrder();
  //   } catch (error) {
  //     toast.error("Failed to update status");
  //   }
  // };

//   useEffect(() => {
//     if (!user.isAuth) {
//       navigate('/');
//     } else {
//       fetchOrder();
//     }
//   }, [user]);

//   return (
//     loading ? (
//       <Loader />
//     ) : (
//       <div className="container mt-4">
//         <h2 className="mb-4">Your Orders</h2>
//         <div className="table-responsive">
//           <table className="table table-bordered table-hover">
//             <thead className="table-dark">
//               <tr>
//                 <th>Id</th>
//                 <th>Item</th>
//                 <th>Quantity</th>
//                 <th>Price</th>
//                 <th>Order Id</th>
//                 <th>Status</th>
//                 <th>Address</th>
//                 <th>Created At</th>
//                 {user.role === 'ADMIN' && <th>Action</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {orders.length > 0 ? (
//                 orders.map((order, index) => (
//                   <tr key={order._id}>
//                     <td>{index + 1}</td>
//                     <td>{order?.productID.map((product) => product?.name).join(', ')}</td>
//                     <td>{order?.productID?.length}</td>
//                     <td>{order?.productID.reduce((total, product) => total + Number(product?.price || 0), 0)}</td>
//                     <td>{order?.razorpay_order_id}</td>
//                     <td>{order?.orderStatus || "Pending"}</td>
//                     <td>
//                       {`${order?.addresseID?.addressLine1}, ${order?.addresseID?.addressLine2}, ${order?.addresseID?.city}, ${order?.addresseID?.state} - ${order?.addresseID?.pinCode}, ${order?.addresseID?.country}`}
//                     </td>
//                     <td>{moment(order.createdAt).format("DD-MM-YYYY hh:mm:ss A")}</td>
//                     {user.role === 'ADMIN' && (
//                       <td>
//                         <div className="d-flex flex-column gap-2">
//                           <Button
//                             size="sm"
//                             variant="success"
//                             onClick={() => handleUpdateStatus(order._id, order.orderStatus === 'Pending' ? 'Delivered' : 'Pending')}
//                           >
//                             Mark as {order.orderStatus === 'Pending' ? 'Delivered' : 'Pending'}
//                           </Button>
//                           <Button
//                             size="sm"
//                             variant="danger"
//                             onClick={() => handleDelete(order._id)}
//                           >
//                             Delete
//                           </Button>
//                         </div>
//                       </td>
//                     )}
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan={user.role === 'ADMIN' ? '9' : '8'} className="text-center">No orders found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     )
//   );
// };

// export default Orders;
